exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-header-action {\n  border: 0 !important;\n  padding: 1.5rem 0 !important;\n}\n\np-editor {\n  width: 100% !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/task/addtask/add-task.component.css
// module id = 2034
// module chunks = 0